/** 导航条 **/
import './index.less';
import React, {useEffect} from 'react';
import {NavBar} from 'antd-mobile';
import IconHome from '@/assets/icons/btn_home@2x.png';
import {baseRoute} from '@views/Application';

const BackHeader = props => {
  const {title, onBeforeBack, right, left, back} = props;
  const onBack = async () => {
    if (onBeforeBack) await onBeforeBack();
    history.back();
  };

  const homeBtn = <img alt="" src={IconHome} width="22" onClick={() => (location.href = baseRoute)} />;

  /*const navBarProps = () => {
    let common = {
      mode: 'light',
      icon: <Icon type="left" color="#302626" />,
      rightContent: 'right' in props ? right : homeBtn,
    };
    if ('left' in props) {
      return {
        ...common,
        leftContent: left,
      };
    } else {
      return {
        ...common,
        onLeftClick: onBack,
      };
    }
  };*/

  return (
    <NavBar
      className={'site-nav-bar'}
      onBack={onBack}
      back={back}
      left={left}
      right={'right' in props ? right : homeBtn}
    >
      {title || '固生堂'}
    </NavBar>
  );
};
export default BackHeader;
